<script lang="ts">
  /**
   * FabButton — the "+" quick-add button of a phone view (plans/mobile-v2.md §3.2):
   * 56×56, fixed at the bottom right, above the tab bar. Each view says what it
   * adds through `label` (Tasks: "Add task", Days: "Add event").
   */
  import Icon from '../Icon.svelte';

  interface Props {
    /** Accessible name, e.g. "Add task". */
    label: string;
    onClick: () => void;
  }

  let { label, onClick }: Props = $props();
</script>

<button type="button" class="fab" aria-label={label} onclick={onClick}>
  <Icon name="plus" size={26} strokeWidth={2} />
</button>

<style>
  .fab {
    position: fixed;
    right: 16px;
    bottom: calc(var(--tabbar-h, 56px) + var(--safe-bottom, 0px) + 16px);
    z-index: 30;
    display: grid;
    place-items: center;
    width: 56px;
    height: 56px;
    padding: 0;
    color: #fff;
    background: #2563eb;
    border: 0;
    border-radius: 50%;
    box-shadow:
      0 6px 16px rgba(37, 99, 235, 0.35),
      0 2px 4px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .fab:active {
    background: #1d4ed8;
    transform: scale(0.96);
  }

  .fab:focus-visible {
    outline: 3px solid #93c5fd;
    outline-offset: 2px;
  }
</style>
